// Pure helpers for the "share AI-analyst conversation" feature.
// Snapshot building lives server-side; this file only holds client-side
// constants and URL helpers.

/** Warning shown wherever a static (conversation/message) share link is created or managed. */
export const SHARE_WARNING =
  "Anyone with this link can view this.";

/**
 * Warning for live scheduleRunner shares — unlike a static snapshot, the link keeps
 * serving the agent's latest result after every future run until sharing is turned off.
 */
export const LIVE_SHARE_WARNING =
  "Anyone with this link can view this agent's latest result, including all future runs, until you turn sharing off.";

/**
 * Build the public, shareable URL for a given shareId.
 * Uses the current origin so it works across environments.
 */
export function buildShareUrl(shareId: string): string {
  return `${window.location.origin}/share/${shareId}`;
}

/** Build the lean, embeddable (no sign-in CTA) URL for a given shareId. */
export function buildEmbedUrl(shareId: string): string {
  return `${window.location.origin}/embed/${shareId}`;
}

/** Build a copy-paste <iframe> snippet pointing at the embed URL, with sensible defaults. */
export function buildEmbedSnippet(shareId: string, width = 600, height = 800): string {
  const src = buildEmbedUrl(shareId);
  return `<iframe src="${src}" width="${width}" height="${height}" loading="lazy" style="border:1px solid #e5e7eb;border-radius:12px;" title="Erode shared agent result"></iframe>`;
}
